export function parseMemberVerificationEmail(value: string): string | null {
  const email = value.trim().toLowerCase();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && email.length <= 254 ? email : null;
}
export function buildMemberEmailVerificationPath(email: string): string {
  return `/api/admin/member-email-verifications?email=${encodeURIComponent(email)}`;
}

export function shouldRevealMemberVerificationCode(row: { code?: unknown } | null): boolean {
  return typeof row?.code === 'string';
}
